import { bigcategoryType } from '@/lib/bigcategory/server'
import { serviceType } from '@/lib/service/server'
import { ChevronRight } from 'lucide-react'
import { Dispatch, SetStateAction, useState } from 'react'

type CategoryListProps = {
  bigcategories: bigcategoryType[]
  open?: boolean
  setOpen?: Dispatch<SetStateAction<boolean>>
  service: serviceType
}

export const BigcategoryList: React.FC<CategoryListProps> = ({
  bigcategories,
  open,
  setOpen,
}) => {
  const [selectedBigcategoryId, setSelectedBigcategoryId] = useState<
    number | null
  >(null)

  const bigcategoriesWithCategory = bigcategories.filter(
    (v) => v.categories.filter((v) => v.hide != true).length > 0,
  )
  const bigcategorieswithoutCategories = bigcategories.filter(
    (v) =>
      v.categories.length === 0 ||
      v.categories.filter((v) => v.hide).length === v.categories.length,
  )
  const validCategories = bigcategoriesWithCategory.concat(
    bigcategorieswithoutCategories,
  )

  const handleBigcategoryClick = (bigcategoryId: number) => {
    if (selectedBigcategoryId === bigcategoryId) {
      setSelectedBigcategoryId(null)
    } else {
      setSelectedBigcategoryId(bigcategoryId)
    }
  }

  const selectedBigcategory = validCategories.find(
    (v) => v.bigcategory_id === selectedBigcategoryId,
  )

  return (
    <div style={{ width: '94%', margin: '12px auto' }}>
      <div className="relative overflow-hidden">
        {/* スライドコンテナ */}
        <div
          className="flex transition-transform duration-300 ease-in-out"
          style={{
            transform:
              selectedBigcategoryId !== null
                ? 'translateX(-100%)'
                : 'translateX(0)',
          }}
        >
          {/* メインビュー */}
          <div className="w-full flex-shrink-0">
            <div className="mb-4">
              <h3 className="text-base font-bold">人気カテゴリ一覧</h3>
            </div>
            <div className="space-y-2">
              {validCategories.map((v) => {
                const visibleCategories = v.categories.filter((c) => !c.hide)
                const hasCategories = visibleCategories.length > 0

                return (
                  <div
                    key={v.bigcategory_id}
                    className="flex items-center justify-between p-3 hover:bg-gray-100 rounded-lg cursor-pointer transition-colors"
                  >
                    <a
                      className="text-sm underline min-w-[100px] max-w-[200px] truncate"
                      href={`/bigcategory/${v.bigcategory_id}`}
                    >
                      {v.name}
                    </a>
                    {hasCategories && (
                      <div
                        className="w-full flex justify-end"
                        onClick={() => {
                          if (hasCategories) {
                            handleBigcategoryClick(v.bigcategory_id)
                          } else {
                            if (open && setOpen) {
                              setOpen(false)
                            }
                          }
                        }}
                      >
                        <ChevronRight className="w-5 h-5 text-gray-400" />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>

          {/* サブカテゴリビュー */}
          <div className="w-full flex-shrink-0">
            {selectedBigcategory && (
              <>
                <div className="mb-4 flex items-center">
                  <button
                    onClick={() => setSelectedBigcategoryId(null)}
                    className="mr-2 p-1 hover:bg-gray-100 rounded"
                  >
                    <ChevronRight className="w-5 h-5 rotate-180" />
                  </button>
                  <p className="text-base font-bold">
                    {selectedBigcategory.name}
                  </p>
                </div>
                <div className="space-y-2">
                  {selectedBigcategory.categories
                    .filter((c) => !c.hide)
                    .map((category) => (
                      <a
                        key={category.category_id}
                        className="block p-3 hover:bg-gray-100 rounded-lg cursor-pointer transition-colors flex items-center justify-between  border-b border-gray-200"
                        href={`/category/${category.category_id}`}
                      >
                        <span className="text-sm">{category.name}</span>
                        <ChevronRight className="w-5 h-5 text-gray-400" />
                      </a>
                    ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
